define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/heading/String"
], function(array,declare,StringRen) {

return declare(StringRen,
	{
		reserveContext: function(/*csi.def.Context*/ctx, /*csi.def.Heading*/h) {
			// summary: render completion date in calendar matrix
			var cal = ctx.view.getViewNode();

			// handle special case where context is milestone activity
			if (cal.$Type == "Milestone") {
				cal = ctx.cache.getNode(cal.__Parent__);
			}

			var actMaster = ctx.getNode();
			var actMasterURL = actMaster.$URL;

			// summary: apply any renderer-specific changes to context before use
			var calendarContainer = ctx.cache.getNode(cal.__Parent__);
			var	actProto = ctx.cache.getNode(actMaster.Proto);
			var levelAct = actProto.ActivityLevel;
			var levelItem = calendarContainer ? ctx.cache.getNode(calendarContainer.CalendarLevel) : null;

			// keep track if activity at same level as calendar parent
			if(levelItem && levelAct == levelItem.$URL) {
				var activities = ctx.cache.getNodes(cal.Activities) || [];
				var milestones = ctx.cache.getNodes(cal.Milestones) || [];
				activities =  activities.concat(milestones);

				var theActivity = null;
				array.some(activities, function (activity) {
					if (activity.Master != actMasterURL)
						return false;
					theActivity =  activity;
					return true;
				}, this);
				if (theActivity) {
					ctx.pushParams().setNode(theActivity);
					h.m_link = "";
					ctx.__popContext = true;
				}
			}

			this.inherited(arguments);
		},

		releaseContext: function(/*csi.def.Context*/ctx, /*csi.def.Heading*/h) {
			// summary: reset link
			if (ctx.__popContext) {
				h.m_link = null;
				ctx.__popContext = false;
				ctx.pop();
			}
			this.inherited(arguments);
		}

	}
);

});